import { axiosInstance } from "../helper/axios";
import KeepLoginMachineLog from "../models/KeepLoginMachineLog";

const KeepLoginMachineLogApi = {
    postKeepLoginMachineLog: (loginLog: KeepLoginMachineLog) => {
        return axiosInstance.post<KeepLoginMachineLog>("api/KeepLoginMachineLog", loginLog);
    }
}

export default KeepLoginMachineLogApi;